// src/plugins/BasePlugin.js

export default class BasePlugin {
    constructor(companyId, debug) {
        this.debug = debug;
        this.companyId = companyId;
    }

    initialize() {
        throw new Error('initialize method must be implemented');
    }

    onShopViewed() {}
    onProductAdded(product) {}
    onOrderConfirmation(order) {}
}
